import React, { useState, useEffect, useRef } from "react";
import { Menu, X } from "lucide-react"; // Icone per il menu
import "../../App.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import logonero from "../../assets/logo bianco.png";
import carosello1 from "../../assets/Foto per transizione/P1088368.jpg";
import carosello2 from "../../assets/Foto per transizione/P1088451.jpg";
import carosello3 from "../../assets/Foto per transizione/P1088330.jpg";
import carosello4 from "../../assets/Foto per transizione/P1088235.jpg";
import carosello5 from "../../assets/Foto per transizione/P1088299.jpg";

const images = [
  { src: carosello1, title: "Identità", link: "#identità" },
  { src: carosello2, title: "Linee", link: "#linee" },
  { src: carosello3, title: "Volti", link: "#volti" },
  { src: carosello4, title: "Contatti", link: "#contatti" },
  { src: carosello5, title: "Luoghi", link: "#luoghi" },
];

const Home = () => {
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const transitionTime = 7000; // Tempo di transizione in ms

  const startAutoPlay = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, transitionTime);
  };

  useEffect(() => {
    document.body.style.overflow = "auto";
    startAutoPlay();
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(activeIndex);
    }
  }, [activeIndex]);

  // Effetto per far avanzare la barra progressiva
  useEffect(() => {
    setProgress(0); // Reset della progress bar quando cambia immagine
    const progressInterval = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 100 : prev + 2)); // Incrementa progressivamente
    }, transitionTime / 50);

    return () => clearInterval(progressInterval);
  }, [activeIndex]);

  const handleManualChange = (index) => {
    setActiveIndex(index);
    startAutoPlay(); // Riavvia l'autoplay
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    pauseOnHover: false,
  };

  const handleScroll = (e, target) => {
    e.preventDefault();
    const section = document.querySelector(target);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div id="Home" className="relative w-full h-screen">
      {/* Navbar */}
      <nav className="absolute top-0 left-0 w-full  bg-opacity-90  text-[white] px-6 md:px-10 py-4 z-50">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <img
            src={logonero}
            alt="logo"
            className="w-[10vh] md:w-18 filter drop-shadow-lg"
          />
          {/* Menu Desktop */}
          <div className="hidden md:flex space-x-6 text-2xl font-semibold">
            <a
              onClick={(e) => handleScroll(e, "#identità")}
              href="#identità"
              className="hover:text-gray-200 transition-colors"
            >
              Identità
            </a>
            <a
              onClick={(e) => handleScroll(e, "#linee")}
              href="#linee"
              className="hover:text-gray-200 transition-colors"
            >
              Linee
            </a>
            <a
              onClick={(e) => handleScroll(e, "#luoghi")}
              href="#linee"
              className="hover:text-gray-200 transition-colors"
            >
              Luoghi
            </a>
            <a
              onClick={(e) => handleScroll(e, "#volti")}
              href="#volti"
              className="hover:text-gray-200 transition-colors"
            >
              Volti
            </a>
            <a
              onClick={(e) => handleScroll(e, "#contatti")}
              href="#contatti"
              className="hover:text-gray-200 transition-colors"
            >
              Contatti
            </a>
          </div>
          {/* Icona menu per Mobile */}
          <button
            className="md:hidden focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
          </button>
        </div>

        {/* Menu Mobile */}
        {isOpen && (
          <div className="md:hidden flex flex-col text-[black] items-center mt-4 space-y-4 text-lg font-semibold bg-white p-4 rounded-lg shadow-lg">
            <a
              onClick={(e) => {
                handleScroll(e, "#identità");
                setIsOpen(!isOpen);
              }}
              href="#identità"
              className="hover:text-gray-600 transition-colors"
            >
              Identità
            </a>
            <a
              onClick={(e) => {
                handleScroll(e, "#linee");
                setIsOpen(!isOpen);
              }}
              href="#linee"
              className="hover:text-gray-600 transition-colors"
            >
              Linee
            </a>
            <a
              onClick={(e) => {
                handleScroll(e, "#luoghi");
                setIsOpen(!isOpen);
              }}
              href="#luoghi"
              className="hover:text-gray-600 transition-colors"
            >
              Luoghi
            </a>
            <a
              onClick={(e) => {
                handleScroll(e, "#volti");
                setIsOpen(!isOpen);
              }}
              href="#volti"
              className="hover:text-gray-600 transition-colors"
            >
              Volti
            </a>
            <a
              onClick={(e) => {
                handleScroll(e, "#contatti");
                setIsOpen(!isOpen);
              }}
              href="#contatti"
              className="hover:text-gray-600 transition-colors"
            >
              Contatti
            </a>
          </div>
        )}
      </nav>

      {/* Slider */}
      <Slider
        {...settings}
        ref={sliderRef}
        className="w-screen h-full overflow-hidden"
      >
        {images.map((image, index) => (
          <div key={index} className="relative w-full h-screen">
            <img
              src={image.src}
              alt={image.title}
              className="w-full h-full object-cover transition-opacity duration-1000 brightness-[60%]"
            />
            <a
              href={image.link}
              onClick={(e) => handleScroll(e, image.link)}
              className="absolute bottom-14 left-10 text-white bg-gradient-to-r from-black via-gray-800 to-black  px-6 py-3 rounded-lg text-xl font-semibold shadow-lg hover:scale-105 transition-transform"
            >
              {image.title}
            </a>
          </div>
        ))}
      </Slider>

      {/* Indicatori Manuali */}
      <div className="absolute bottom-5 left-5 flex space-x-4 z-10">
        {images.map((_, index) => (
          <div key={index} className="relative flex flex-col items-center">
            {/* Puntino principale */}
            <button
              onClick={() => handleManualChange(index)}
              className={`w-4 h-4 rounded-full transition-all duration-300 ${
                index === activeIndex
                  ? "bg-white scale-125"
                  : "bg-gray-600 opacity-50"
              }`}
            />
            {/* Barra progressiva che si anima solo sul puntino attivo */}
            <div className="relative w-6 h-1 mt-1 bg-gray-700 rounded-full overflow-hidden">
              <div
                className="absolute top-0 left-0 h-full bg-white transition-all"
                style={{
                  width: index === activeIndex ? `${progress}%` : "0%",
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
